module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("e9cLI"))).then(() => parcelRequire('fThBo'));